module.exports = __webpack_public_path__ + "static/media/alipay.ac095d37.png";